<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else class="container">
      <div class="row">
        <div class="col-xs-6">
          <HelpText>
            <h3>
              Create Channel
            </h3>

            <p>
              Enter the details of the channel.
            </p>
          </HelpText>
        </div>

        <div class="col-xs-18">
          <div class="panel panel-default">
            <div class="panel-body">
              <form @submit.prevent="submit" class="form-horizontal">
                <RadioFormGroup
                    v-model="type"
                    name="type"
                    label="Type"
                    help-text="The type of the channel."
                    :error="getError('type')"
                    :options="typeOptions"
                />

                <TextFormGroup
                    v-model="channel.name"
                    name="name"
                    label="Name"
                    help-text="The name of the channel."
                    :error="getError('name')"
                />

                <ColorFormGroup
                    v-model="channel.color"
                    name="color"
                    label="Color"
                    help-text="The color of the channel."
                    :colors="colors.data"
                    :error="getError('color')"
                />

                <SelectFormGroup
                    v-model="channel.accounting_system_product_number"
                    name="accounting_system_product_number"
                    label="Accounting System Product"
                    help-text="The product in the accounting system that the channel belongs to."
                    :error="getError('accounting_system_product_number')"
                    :options="accountingSystemProductNumberOptions"
                />

                <SelectFormGroup
                    v-model="channel.channel_type"
                    name="channel_type"
                    label="Channel Type"
                    help-text="The channel type of the channel."
                    :error="getError('channel_type')"
                    :options="channelTypeOptions"
                    :nullable="true"
                />

                <NumberFormGroup
                    v-model="channel.default_content_deadline_period"
                    name="default_content_deadline_period"
                    label="Default Content Deadline"
                    help-text="The default number of days before publication of the ad that the content should be submitted."
                    :error="getError('default_content_deadline_period')"
                />

                <NumberFormGroup
                    v-model="channel.default_content_deadline_reminder_period"
                    name="default_content_deadline_reminder_period"
                    label="Default Content Deadline Reminder"
                    help-text="The default number of days before the content deadline of the ad that a reminder should be sent to the content responsible."
                    :error="getError('default_content_deadline_period')"
                />

                <hr>

                <SubmitFormGroup button-class="btn-black"/>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import ColorFormGroup from '@/components/FormGroups/Horizontal/Color'
import Errors from '@/mixins/Errors'
import HelpText from '@/components/HelpText'
import Load from '@/mixins/Load'
import LoadingContainer from '@/components/Layout/LoadingContainer'
import NumberFormGroup from '@/vendor/forms/FormGroups/Horizontal/Number'
import RadioFormGroup from '@/vendor/forms/FormGroups/Horizontal/Radio'
import SelectFormGroup from '@/vendor/forms/FormGroups/Horizontal/Select'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'
import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

export default {
  components: {
    ColorFormGroup,
    HelpText,
    LoadingContainer,
    NumberFormGroup,
    RadioFormGroup,
    SelectFormGroup,
    SubmitFormGroup,
    TextFormGroup
  },

  mixins: [Errors, Load],

  model: {
    prop: 'portal',
    event: 'portal-updated'
  },

  props: ['portal'],

  data() {
    return {
      type: null,
      accountingSystemProducts: [],
      channelTypes: [],
      colors: [],
      channel: {
        portal_id: this.portal.id
      }
    }
  },

  mounted() {
    this.load({
      accountingSystemProducts: '/api/v2/bookkeeping-products',
      colors: '/api/v2/colors',
      channelTypes: '/api/v2/channel-types'
    })
  },

  computed: {
    typeOptions() {
      return [
        {value: 'time', label: 'Time Based'},
        {value: 'publication', label: 'Publication Based'}
      ]
    },

    accountingSystemProductNumberOptions() {
      return this.accountingSystemProducts.data.map(accountingSystemProduct => {
        return {
          value: accountingSystemProduct.id,
          label: accountingSystemProduct.attributes.name
        }
      })
    },

    channelTypeOptions() {
      return this.channelTypes.data.map(channelType => {
        return {
          value: channelType.id,
          label: channelType.attributes.name
        }
      })
    },

    url() {
      switch (this.type){
        case 'publication':
          return  '/api/v2/publication-based-channels'
        case 'time':
          return  '/api/v2/time-based-channels'
      }
    }
  },

  methods: {
    submit() {
      if (!this.type) {
        return notify.error('Select a type')
      }

      http.post(this.url, this.channel)
          .then(() => {
            notify.success('The channel was saved')

            this.$router.push('/portals/' + this.portal.id + '/channels')
          })
          .catch(this.catchValidationErrors)
    }
  }
}
</script>
